import type { AxiosError } from 'axios';

type ApiErrorPayload = { error?: { code?: string; message?: string } };

/** Fallback copy when the API returns a rate-limit code without a message body. */
const RATE_LIMIT_MESSAGE_BY_CODE: Record<string, string> = {
  AUTH_RATE_LIMIT_STRICT_IP:
    'Too many attempts from this network. Please try again later.',
  AUTH_RATE_LIMIT_RELAXED_IP:
    'Too many attempts from this network. Please try again later.',
  AUTH_RATE_LIMIT_EMAIL:
    'Too many attempts for this email address. Please try again later.',
  AUTH_RATE_LIMIT_GENERIC:
    'Too many requests. Please try again later.',
};

export function normalizeAxiosApiError(error: AxiosError): void {
  const apiCode = (error.response?.data as ApiErrorPayload)?.error?.code;
  if (apiCode != null && apiCode !== '') {
    Object.assign(error, { code: apiCode });
  }
}

const GENERIC_RATE_LIMIT_FALLBACK =
  'Too many requests. Please try again later.';

export function getRateLimitNotificationMessage(error: AxiosError): string {
  const payload = error.response?.data as ApiErrorPayload | undefined;
  const fromApi = payload?.error?.message?.trim();
  if (fromApi) return fromApi;
  const code = payload?.error?.code;
  if (code != null && code !== '') {
    return RATE_LIMIT_MESSAGE_BY_CODE[code] ?? GENERIC_RATE_LIMIT_FALLBACK;
  }
  return GENERIC_RATE_LIMIT_FALLBACK;
}
